import type {
  ApiBankEntryResponse,
  ApiFundTransactionDetail,
  ApiFundTransactionSummary,
  BankEntryResponse,
  FundTransactionDetail,
  FundTransactionSummary,
} from '@/types/fund-transactions';
import { toNumber } from '@/utils/number-operations';

export function mapFundTransactionSummary(
  dto: ApiFundTransactionSummary
): FundTransactionSummary {
  return {
    ...dto,
    amount: toNumber(dto.amount),
  };
}

export function mapFundTransactionDetail(
  dto: ApiFundTransactionDetail
): FundTransactionDetail {
  return {
    ...mapFundTransactionSummary(dto),
    currency_id: dto.currency_id,
    management_fee: dto.management_fee
      ? {
          ...dto.management_fee,
          fee_basis_amount: toNumber(dto.management_fee.fee_basis_amount),
          annual_rate: toNumber(dto.management_fee.annual_rate),
          day_fraction: toNumber(dto.management_fee.day_fraction),
        }
      : null,
    fund_cost: dto.fund_cost,
    deal_cost: dto.deal_cost,
    distribution: dto.distribution
      ? {
          ...dto.distribution,
          gross_amount: toNumber(dto.distribution.gross_amount),
          total_deductions: toNumber(dto.distribution.total_deductions),
          net_amount: toNumber(dto.distribution.net_amount),
        }
      : null,
    drawdown: dto.drawdown,
    asset_sale: dto.asset_sale ?? null,
    financing_round: dto.financing_round ?? null,
    convertible: dto.convertible ?? null,
    currency_conversion: dto.currency_conversion ?? null,
    fx_period_end: dto.fx_period_end ?? null,
    lp_transfer: dto.lp_transfer ?? null,
  };
}

export function mapBankEntryResponse(
  dto: ApiBankEntryResponse
): BankEntryResponse {
  return {
    ...dto,
    amount: toNumber(dto.amount),
  };
}
